<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('inventoryList.hoInventoryList') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('inventoryList.hoInventoryList'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('inventoryList.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('inventoryList.dateRange')
                          }}</label>
                          <a-range-picker
                            format="DD-MM-YYYY"
                            :defaultValue="rangeDate"
                            :defaultPickerValue="rangeDate"
                            @change="dateRangeChange"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('inventoryList.product') }}</label>
                          <treeselect
                            :options="products"
                            :placeholder="$t('all')"
                            :multiple="true"
                            :limit="1"
                            v-model="model.product_id"
                            openDirection="top"
                            :maxHeight="150"
                          ></treeselect>
                          <div class="validate" v-if="errors.has('product_id')">
                            {{ errors.first('product_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          outline
                          color="success"
                          class="btn-block"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          color="danger"
                          outline
                          class="btn-block"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="far fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('inventoryList.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'InventoryListHeadOffice',
  data() {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      locations: [],
      branches: [],
      products: [],
      src: '',
      rangeDate: [moment(), moment()],
      model: {
        product_id: []
      }
    }
  },
  created() {
    this.fetchPreData()
  },
  methods: {
    ...mapActions('reportInventory', [
      'inventoryListHeadOffice',
      'getProductProfile'
    ]),
    moment,
    async fetchPreData() {
      this.loading = true
      this.getProductProfile({
        fields: {
          setup_inventory_products: 'product_id,product_name_en'
        },
        page: -1
      })
        .then(response => {
          this.products = response.data.map(el => ({
            id: el.product_id,
            label: el.product_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.inventoryListHeadOffice(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('reportInventory/inventoryListHeadOfficeExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'reportInventory/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportInventory/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    }
  }
}
</script>
